import Modal from "../../modules/Modal";
export default class OrderUpdateConfirmationModal {
    constructor() {
        var _a;
        this.redirectUrl = null;
        this.container = document.querySelector('[data-order-update-confirmation-modal]');
        if (!this.container) {
            return;
        }
        this.modal = new Modal('order-update-confirmation');
        this.closeButton = this.container.querySelector('[data-close-and-redirect]');
        this.texts = ((_a = this.container) === null || _a === void 0 ? void 0 : _a.dataset.texts) ? JSON.parse(this.container.dataset.texts) : {};
        this.init();
    }
    init() {
        if (this.closeButton) {
            this.closeButton.addEventListener('click', () => {
                this.handleClose();
            });
        }
    }
    show(title, redirectUrl) {
        this.redirectUrl = redirectUrl;
        this.updateOrderInfo(title);
        this.modal.open();
    }
    updateOrderInfo(title) {
        const orderNamePlaceholder = this.container.querySelector('[data-order-name-placeholder]');
        if (orderNamePlaceholder) {
            orderNamePlaceholder.innerHTML = title;
        }
    }
    handleClose() {
        this.modal.close();
        if (this.redirectUrl) {
            window.location.href = this.redirectUrl;
        }
    }
}
